import { render, staticRenderFns } from "./bv-suspend.vue?vue&type=template&id=d20b1e74&scoped=true"
import script from "./bv-suspend.vue?vue&type=script&lang=js"
export * from "./bv-suspend.vue?vue&type=script&lang=js"
import style0 from "./bv-suspend.vue?vue&type=style&index=0&id=d20b1e74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../apps/gouwubao/node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20b1e74",
  null
  
)

export default component.exports